import gql from 'graphql-tag';

const costCenterQueries = {

    allCostCenters: gql`
        query Costcenters {
            costcenters(count: 9999, orderBy: [{ field: "number", order: ASC }]) {
                data {
                    id
                    number
                    name
                    color
                    closed
                }
            }
        }
    `,

};

export default costCenterQueries;
